import React from 'react';
import { ArrowRightIcon } from 'lucide-react';
import { TRANSFORM_BEFORE, TRANSFORM_AFTER } from './salesData';
export function TransformationSection() {
  return <section id="transformacion" className="bg-cream py-14 sm:py-20" data-id="element-319" data-mp="31uw4opnil0yf">
      <div className="mx-auto max-w-5xl px-5" data-id="element-320" data-mp="2ww2ouqkr8xv3">
        <h2 className="mx-auto max-w-[20ch] text-center font-display text-[1.6rem] font-extrabold leading-[1.15] tracking-tight text-charcoal sm:max-w-[30ch] sm:text-[2.4rem]" data-id="element-321" data-mp="2ryt0le93qs8u">
          El objetivo no es que termines de leer.
          <span className="block text-gold" data-id="element-322" data-mp="2j57m7w0unczy">El objetivo es que empieces.</span>
        </h2>

        <div className="mt-10 grid gap-4 md:grid-cols-[minmax(0,1fr)_auto_minmax(0,1fr)] md:items-stretch" data-id="element-323" data-mp="2e6cxkdg7au7x">
          <div className="rounded-3xl border border-stone bg-white/70 p-6" data-id="element-324" data-mp="2994abyg73zzt">
            <p className="font-display text-[0.68rem] font-bold uppercase tracking-editorial text-taupe" data-id="element-325" data-mp="249hvjkkpybow">
              Antes
            </p>
            <p className="mt-3 font-sans text-[1rem] font-semibold leading-snug text-charcoal/70 sm:text-[1.08rem]" data-id="element-326" data-mp="207wm697e8fjg">
              “Me gustaría vender algo desde casa, pero no sé por dónde empezar.”
            </p>
            <ul className="mt-5 space-y-2.5 border-t border-stone pt-5" data-id="element-327" data-mp="k3vpzznodbsd">
              {TRANSFORM_BEFORE.map(item => <li key={item} className="font-sans text-[0.86rem] leading-snug text-taupe" data-id="element-328" data-mp="abzftq8bdv7s">
                  {item}
                </li>)}
            </ul>
          </div>

          <div className="flex items-center justify-center md:px-1" data-id="element-329" data-mp="xzr31ove7snu">
            <span className="flex h-11 w-11 items-center justify-center rounded-full bg-gold shadow-[0_12px_26px_-12px_rgba(232,62,115,0.8)]" data-id="element-330" data-mp="13051qgb3tq97">
              <ArrowRightIcon className="h-5 w-5 rotate-90 text-white md:rotate-0" aria-hidden strokeWidth={3} data-id="element-331" data-mp="t27b5m5rvhdf" />
            </span>
          </div>

          <div className="rounded-3xl border border-stone bg-sand p-6" data-id="element-332" data-mp="3dt7szws3k6w6">
            <p className="font-display text-[0.68rem] font-bold uppercase tracking-editorial text-gold-deep" data-id="element-333" data-mp="3dqdawbwk2y5x">
              Después
            </p>
            <p className="mt-3 font-sans text-[1rem] font-semibold leading-snug text-charcoal sm:text-[1.08rem]" data-id="element-334" data-mp="1fbxmczuts7zw">
              “Tengo 5 productos elegidos, sé qué comprar, cómo producirlos, cuánto cobrar, cómo
              mostrarlos y qué hacer para buscar mis primeras ventas.”
            </p>
            <ul className="mt-5 space-y-2.5 border-t border-stone pt-5" data-id="element-335" data-mp="11kj08k5mfqom">
              {TRANSFORM_AFTER.map(item => <li key={item} className="flex gap-2.5 font-sans text-[0.86rem] font-semibold leading-snug text-charcoal" data-id="element-336" data-mp="witsbddp3t4r">
                  <span className="mt-1.5 h-1.5 w-1.5 shrink-0 rounded-full bg-gold" aria-hidden data-id="element-337" data-mp="mna6xkwrccu9" />
                  {item}
                </li>)}
            </ul>
          </div>
        </div>
      </div>
    </section>;
}